/** Accept / Decline for an offer I must answer. */
import {useCallback} from 'react';

import {useLiveGame} from '@/Store/liveGameStore';

export type DrawOfferCardModel = {
  onAccept: () => void;
  onDecline: () => void;
};

export function useDrawOfferCardModel(): DrawOfferCardModel {
  const answerDraw = useLiveGame(s => s.actions.answerDraw);
  return {
    onAccept: useCallback(() => answerDraw(true), [answerDraw]),
    onDecline: useCallback(() => answerDraw(false), [answerDraw]),
  };
}
